import type { FC, PropsWithChildren } from 'react';

import { Icon } from '@trend-dev/ui-libs-icons';

import styles from './styles.module.scss';

const Mark: FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className={styles.wrapper}>
            {children}
            <div className={styles.granted}>
                <Icon name='Check_20' />
            </div>
        </div>
    );
};

export default Mark;
